import React from "react";
import "./ArticlePreviewSepItem.css";

class ArticlePreviewSepItem extends React.Component {
  render() {
    return (
      <div className="preview_sep">
        <span className="dot" />
        <span className="dot" />
        <span className="dot" />
      </div>
    );
  }
}

export default ArticlePreviewSepItem;
